import {
  AllGames,
  AllGamesApi,
  CreateGamePromotionalMessageRequest,
  DeleteGamePromotionalMessageRequest,
  GameBranding,
  GameBrandingUpdateRequest,
  GamePromotionalMessage,
  GamePromotionalMessageCreateRequest,
  GamePromotionalMessageUpdateRequest,
  GameDisplayOrder,
  GameDisplayOrders,
  GamesAdminApi,
  GetAllGamesRequest,
  SetGameDisplayOrderRequest,
  GetGamePromotionalMessagesRequest,
  UpdateGameBrandingRequest,
  UpdateGamePromotionalMessageRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(AllGamesApi)

const getAdminApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(GamesAdminApi)

const getAllGames = async (
  includeInactive?: boolean,
  includeUpcoming?: boolean,
  includeHistorical?: boolean,
): Promise<AllGames> => {
  const request: GetAllGamesRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    includeInactive,
    includeUpcoming,
    includeHistorical,
  }

  return await getApi().getAllGames(request)
}

const getGamePromotionalMessages = async (gameId: string): Promise<GamePromotionalMessage[]> => {
  const request: GetGamePromotionalMessagesRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
  }

  return await getAdminApi().getGamePromotionalMessages(request)
}

const createGamePromotionalMessage = async (
  gameId: string,
  message: GamePromotionalMessageCreateRequest,
): Promise<GamePromotionalMessage> => {
  const request: CreateGamePromotionalMessageRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
    gamePromotionalMessageCreateRequest: message,
  }

  return await getAdminApi().createGamePromotionalMessage(request)
}

const updateGamePromotionalMessage = async (
  gameId: string,
  id: string,
  updates: GamePromotionalMessageUpdateRequest,
): Promise<GamePromotionalMessage> => {
  const request: UpdateGamePromotionalMessageRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
    id,
    gamePromotionalMessageUpdateRequest: updates,
  }

  return await getAdminApi().updateGamePromotionalMessage(request)
}

const deleteGamePromotionalMessage = async (gameId: string, id: string): Promise<void> => {
  const request: DeleteGamePromotionalMessageRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
    id,
  }

  return await getAdminApi().deleteGamePromotionalMessage(request)
}

// The endpoint replaces branding wholesale, so a caller must send every field it wants kept.
const updateGameBranding = async (
  gameId: string,
  branding: GameBrandingUpdateRequest,
): Promise<GameBranding> => {
  const request: UpdateGameBrandingRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
    gameBrandingUpdateRequest: branding,
  }

  return await getAdminApi().updateGameBranding(request)
}

const setGameDisplayOrder = async (items: GameDisplayOrder[]): Promise<GameDisplayOrders> => {
  const request: SetGameDisplayOrderRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameDisplayOrderUpdateRequest: { items },
  }

  return await getAdminApi().setGameDisplayOrder(request)
}

export const GamesServiceAPI = {
  getAllGames,
  getGamePromotionalMessages,
  createGamePromotionalMessage,
  updateGamePromotionalMessage,
  deleteGamePromotionalMessage,
  updateGameBranding,
  setGameDisplayOrder,
}
